import { render, staticRenderFns } from "./NewContest.vue?vue&type=template&id=229ad4d4&"
import script from "./NewContest.vue?vue&type=script&lang=js&"
export * from "./NewContest.vue?vue&type=script&lang=js&"
import style0 from "./NewContest.vue?vue&type=style&index=0&id=229ad4d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports